import React, { useState, useEffect } from 'react';
import { countries } from '../utils/countries';
import { countryTimezones, timezoneLabels } from '../utils/countryTimezones';

const CountryTimezoneSelector = ({
  onCountryChange,
  onTimezoneChange,
  selectedCountry,
  selectedTimezone,
  isCountryOnly = false,
  isTimezoneOnly = false,
  className = ""
}) => {
  const [availableTimezones, setAvailableTimezones] = useState([]);

  useEffect(() => {
    if (selectedCountry) {
      const timezones = countryTimezones[selectedCountry] || [];
      setAvailableTimezones(timezones);
    } else {
      setAvailableTimezones([]);
    }
  }, [selectedCountry]);

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    onCountryChange(countryCode);
    onTimezoneChange(''); // Reset timezone when country changes
  };

  if (isCountryOnly) {
    return (
      <select
        id="country"
        value={selectedCountry}
        onChange={handleCountryChange}
        className={`form-input ${className}`}
      >
        <option value="">Select your country</option>
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            {country.name}
          </option>
        ))}
      </select>
    );
  }

  if (isTimezoneOnly) {
    return (
      <select
        id="timezone"
        value={selectedTimezone}
        onChange={(e) => onTimezoneChange(e.target.value)}
        className={`form-input ${className}`}
        disabled={!selectedCountry || availableTimezones.length === 0}
      >
        <option value="">Select timezone</option>
        {availableTimezones.map((timezone) => (
          <option key={timezone} value={timezone}>
            {timezoneLabels[timezone] || timezone}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className={`country-timezone-pair ${className}`}>
      <div className="form-group">
        <label className="form-label" htmlFor="country">Country</label>
        <select
          id="country"
          value={selectedCountry}
          onChange={handleCountryChange}
          className="form-input"
        >
          <option value="">Select your country</option>
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="timezone">Timezone</label>
        <select
          id="timezone"
          value={selectedTimezone}
          onChange={(e) => onTimezoneChange(e.target.value)}
          className="form-input"
          disabled={!selectedCountry || availableTimezones.length === 0}
        >
          <option value="">Select timezone</option>
          {availableTimezones.map((timezone) => (
            <option key={timezone} value={timezone}>
              {timezoneLabels[timezone] || timezone}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CountryTimezoneSelector;